
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('discipline') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/discipline/create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('EmployeeName')">{{ $t('name') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('DisciplineDate')">{{ $t('date') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('TypeId')">{{ $t('type') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Description')">{{ $t('description') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Amount')">{{ $t('total_amount') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting" style="width: 80px;">
                                    <span class="sort-field" @click="onSort('Status')">{{ $t('status') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{name: 'discipline_update', params:{id:ret.DisciplineId}}">{{ret.EmployeeName}}</router-link></td>
                                <td>{{$format(ret.DisciplineDate,'DD/MM/YYYY')}}</td>
                                <td>{{ret.TypeId}}</td>
                                <td>{{ret.Description}}</td>
                                <td class="text-right">{{$money(ret.Amount)}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function(){
        return {
            query:{
                Text: '',
                FromDate: '',
                ToDate: '',
                Page: 1,
                Total: 0,
                Limit: 25,
                Status: '',
                SortType: '',
                SortField: ''
            },
            records:[]
        }
    },
    created: function(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('employee/discipline/list', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Disciplines;
                    this.query.Total = res.data.Total;
                }
            }).finally(function() { loading.hide(); });
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        },
        onSort(field){
            this.query.SortField = field;
            if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
            else this.query.SortType = 'ASC';
            this.toList();
        }
    }
}
</script>
